var render = function render(){var _vm=this,_c=_vm._self._c;return _c('detail',{attrs:{"data":_vm.data,"base-info":_vm.baseInfo,"extra-info":_vm.extraInfo,"on-manager":_vm.onManager,"resource":_vm.resource,"status-module":"image"}})
}
var staticRenderFns = []

export { render, staticRenderFns }